import React, { useState } from "react";
import dummyProfileNew from "../../widgets/bookingWidget/bookingModal/images/dummyProfileNew.png";
import inviteImage from "../../widgets/bookingWidget/bookingModal/images/inviteDum2.svg";
import sendRequest from "../../widgets/bookingWidget/bookingModal/images/sentRequestIcon.svg";
import { correctLevelWithPoints } from "../../Utilities/utils";
import ProfileELOBadge from "../profile/ProfileEloBadge/ProfileEloBadge";

const UserProfilePicOpenMatches = ({
    player,
    gameType,
    isRequested,
    playerNumber,
    userData
}: any) => {
    const [fillColor, setFillColor] = useState<string | null>(null);

    const profilePicBorderColor = player?.email?.includes("@mailinator.com")
        ? "transparent"
        : fillColor ?? "#FCE76D"; // fallback color

    const getProfilePicSource = (player: any) => {
        if (
            (!player?.profilePic || player?.profilePic === "") &&
            (!player?.profilePicThumb || player?.profilePicThumb === "")
        ) {
            return null;
        } else if (player?.profilePicThumb || player?.profilePic) {
            const uri = player?.profilePicThumb || player?.profilePic;

            if (uri?.includes("https://platform-lookaside.fbsb")) {
                return {
                    uri:
                        uri
                            ?.replace(
                                "https://platform-lookaside.fbsbx.com/platform/profilepic/?asid=",
                                "https://graph.facebook.com/"
                            )
                            ?.replace("&", "/picture")
                            ?.split("height")[0] + "?type=large"
                };
            } else if (uri?.includes("https://graph.facebook.com/")) {
                return { uri: uri + "?type=large" };
            } else {
                return { uri };
            }
        } else {
            return null;
        }
    };

    const handleFillChange = (fill: string) => {
        setFillColor(fill);
    };

    //   const isBlueImage = () => {
    //     return player?.count < 7 || player?.pun < 1;
    //   };

    return (
        <div className="relative w-9 h-9">
            <div className="rounded-full w-9 h-9 relative">
                {isRequested === playerNumber ? (
                    <div className="w-9 h-9 rounded-full bg-green-500 flex items-center justify-center">
                        <img
                            src={sendRequest}
                            alt="Sent Request"
                            className="w-9 h-9 rounded-full"
                        />
                    </div>
                ) : (
                    <>
                        {!player || player === "" ? (
                            <div className="bg-gray-400 w-9 h-9 rounded-full flex items-center justify-center">
                                {/* <InviteIcon width={36} height={36} /> */}
                                <img
                                    src={inviteImage}
                                    alt="Invite Player"
                                    className="w-9 h-9 rounded-full"
                                />
                            </div>
                        ) : (
                            <img
                                className={`w-9 h-9 rounded-full object-cover ${
                                    player?.pro ? "border-2" : ""
                                }`}
                                src={getProfilePicSource(player)?.uri || dummyProfileNew}
                                alt="Profile"
                                style={{ borderColor: profilePicBorderColor }}
                            />
                        )}
                    </>
                )}
            </div>

            {player &&
                player !== "" &&
                !player?.email?.includes("@mailinator.com") && (
                    <>
                        <div
                            className="bg-secondary text-white w-8 h-4 rounded-full text-[10px] font-medium flex items-center justify-center mx-auto -bottom-1 left-[1px] absolute"
                            style={{
                                borderColor: fillColor ?? "#FCE76D",
                                borderWidth: "1px"
                            }}
                        >
                            {correctLevelWithPoints(player)}
                        </div>

                        <ProfileELOBadge
                            player={player}
                            gameType={gameType}
                            onFillChange={handleFillChange}
                            userData={userData}
                            containerStyle=''
                        />
                    </>
                )}
        </div>
    );
};

export default UserProfilePicOpenMatches;
